module.exports = __webpack_public_path__ + "static/media/mega645.b2827d90.png";